import { render, staticRenderFns } from "./ComSystem.vue?vue&type=template&id=3c15af9e&scoped=true&"
import script from "./ComSystem.vue?vue&type=script&lang=js&"
export * from "./ComSystem.vue?vue&type=script&lang=js&"
import style0 from "./ComSystem.vue?vue&type=style&index=0&id=3c15af9e&lang=scss&scoped=true&"
import style1 from "./ComSystem.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c15af9e",
  null
  
)

export default component.exports